export default "__VITE_ASSET__Dv_P5H5M__"